// extracted by mini-css-extract-plugin
export default {"root":"PageBuilderButtons-module-root-1UT","buttonsHaveSameWidth":"PageBuilderButtons-module-buttonsHaveSameWidth--bb"};